'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'industry-windows';
var width = 576;
var height = 512;
var aliases = [127981,"industry-alt"];
var unicode = 'f3b3';
var svgPathData = 'M32 32l128 0 0 192 192-96 0 96 192-96 0 96 0 256L32 480l0-96 0-160L32 32zM328 312l-80 0 0 80 80 0 0-80zm-128 0l-80 0 0 80 80 0 0-80zm256 0l-80 0 0 80 80 0 0-80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIndustryWindows = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;